import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  format_date,
  GET,
  PUT,
  UPLOAD,
  t,
  can,
} from "../../components/CustomComponent.js";
import { EMPTY_GROUP, ADMIN_ICON, clone } from "../../components/homepage_option.js";
import { lineAddUrl } from "../../components/people_option.js";
import HomeMedia from "../homepage/components/HomeMedia.js";
import HOME_ICON from "../homepage/icons.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * จัดการหน้าแรก › ลงประกาศฟรี  (/ad/home/post)
 *
 * คุมสองอย่างของการ์ด "ลงประกาศฟรี" ที่อยู่ข้างแบนเนอร์บนหน้าแรก
 *   รูปในการ์ด  ไม่ใส่ก็ได้ — หน้าเว็บจะวาดภาพจำลอง (เส้นขอบฟ้า) ให้เหมือนเดิม
 *   LINE ID     ปลายทางของปุ่ม "ลงประกาศฟรี" ทุกปุ่มบนเว็บลูกค้า (เมนูบน /
 *               การ์ดข้างแบนเนอร์ / ฟุตเตอร์) กดแล้วถามยืนยันก่อนพาไปเพิ่มเพื่อน
 *
 * ระบบยังไม่มีหน้าลงประกาศของตัวเอง ผู้สนใจจึงถูกพาไปคุยกับทีมงานทาง LINE
 * ไม่ได้ตั้ง LINE ID ไว้ = ปุ่มยังแจ้ง "กำลังพัฒนา" เหมือนก่อนหน้านี้
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/post
 *   PUT  admin/homepage/post   (ส่ง { setting: { src, line_id } })
 * ========================================================================== */

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomePostSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setting: clone(EMPTY_GROUP.post.setting),
      saved: clone(EMPTY_GROUP.post.setting),
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/post", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) => {
    const setting = { ...EMPTY_GROUP.post.setting, ...(data.setting || {}) };
    this.setState({
      setting,
      saved: clone(setting),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });
  };

  isDirty = () => JSON.stringify(this.state.setting) !== JSON.stringify(this.state.saved);

  setSetting = (patch) => this.setState((prev) => ({ setting: { ...prev.setting, ...patch } }));

  /* อัปโหลดขึ้น storage ทันทีแล้วเก็บเป็น URL — ไม่เก็บ base64 ลงฐานข้อมูล
     ชุดเดียวกับรูปแบนเนอร์/ภาพพื้นหลังหน้าแรก */
  PickImage = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // เลือกไฟล์เดิมซ้ำได้
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return alert("", "warning", t("warning"), t("home_verify_image_size"));

    loading(true);
    const result = await UPLOAD(file, { folder: "homepage/post" });
    loading(false);

    if (!result?.status || !result.data?.file_path) {
      return alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    this.setSetting({ src: result.data.file_path });
  };

  Save = async () => {
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    const payload = {
      src: this.state.setting.src,
      line_id: this.state.setting.line_id.trim(),
    };

    loading(true);
    const result = await PUT("admin/homepage/post", { setting: payload });
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ setting: clone(prev.saved) }));
  };

  /* =============================================== render : ฟอร์มตั้งค่า */
  renderForm = () => {
    const { setting } = this.state;
    const dirty = this.isDirty();
    const url = lineAddUrl(setting.line_id.trim());
    const editable = can("homepage.update");

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_post_setting_title")}
          </span>
        </div>

        <div className="p-3">
          <div className="row g-3">
            {/* รูปในการ์ด : ไม่บังคับ ไม่ใส่ก็ใช้ภาพจำลองเหมือนเดิม */}
            <div className="col-12">
              <label className="prop-label">{t("home_post_image")}</label>
              <label className={`hmg-drop ${setting.src ? "has-image" : ""}`}>
                <input type="file" accept="image/*" disabled={!editable} onChange={this.PickImage} />
                {setting.src && <img src={setting.src} alt="preview" />}
                <span className="hmg-drop__tip">
                  <span className="icon">{ADMIN_ICON.photo}</span>
                  {setting.src ? t("change_image") : t("home_pick_image")}
                </span>
              </label>
              <div className="ppl-sub mt-1">{t("home_post_image_hint")}</div>
              {!!setting.src && editable && (
                <button type="button" className="prop-link mt-2" onClick={() => this.setSetting({ src: "" })}>
                  <span className="icon text-12">{ADMIN_ICON.trash}</span>
                  {t("home_remove_image")}
                </button>
              )}
            </div>

            {/* LINE ID : ปลายทางของปุ่มลงประกาศฟรีทุกปุ่มบนเว็บลูกค้า */}
            <div className="col-12">
              <label className="prop-label">{t("home_post_line_id")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={200}
                placeholder="@safespacelifeliving"
                disabled={!editable}
                value={setting.line_id}
                onChange={(e) => this.setSetting({ line_id: e.target.value })}
              />
              <div className="ppl-sub mt-1">{t("home_post_line_id_hint")}</div>
            </div>

            {/* ลิงก์ที่ระบบจะพาไปจริง — ตรวจได้ก่อนบันทึกว่าถูกบัญชี */}
            <div className="col-12">
              {url ? (
                <div className="ppl-note">
                  <span className="icon">{ADMIN_ICON.link}</span>
                  <div>
                    <div className="text-12 fw-bold mb-1">{t("home_post_line_preview")}</div>
                    <a className="prop-link" href={url} target="_blank" rel="noreferrer">
                      {url}
                    </a>
                  </div>
                </div>
              ) : (
                <div className="ppl-note">
                  <span className="icon">{ADMIN_ICON.info}</span>
                  <div>{t("home_post_line_empty")}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {editable && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* =============================================== render : กล่องพรีวิว */
  /* ใช้ markup + CSS ชุดเดียวกับการ์ดจริงบนหน้าแรก (.hm-side-card) จึงเห็นของจริง */
  renderPreview = () => {
    const { setting } = this.state;

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href="/" target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com</span>
            </div>
            <div className="hmg-frame__body">
              <div className="mn-home">
                <div className="hm-side-card hm-side-card--tint" style={{ minHeight: "260px" }}>
                  <div className="hm-side-card__body">
                    <div className="hm-side-card__head">
                      <div className="hm-side-card__title">{t("home_promo_post_title")}</div>
                      <span className="hm-btn hm-btn--primary hm-btn--sm hm-side-card__cta">
                        <span className="hm-ico">{HOME_ICON.bullhorn}</span>
                        {t("home_promo_post_cta")}
                      </span>
                    </div>
                    <div className="hm-side-card__desc">{t("home_promo_post_desc")}</div>
                  </div>
                  <div className="hm-side-card__art">
                    {setting.src ? (
                      <img className="hm-side-card__img" src={setting.src} alt="" aria-hidden="true" />
                    ) : (
                      <HomeMedia kind="skyline" tone={5} ratio={0.62} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_post_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { updated_at, updated_by } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_post_manage")}</h3>
              <div className="text-secondary text-14">{t("home_post_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-xl-7 col-lg-7">{this.renderForm()}</div>
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>
      </div>
    );
  }
}
